import "../styles/Footer.css";

function Footer() {
  return (
    <footer>
      <p>
        Copyright © Rachael Cole 2022. This project is&nbsp;
        <a href="https://github.com/jcrachael/pokemon-memory-game">
          open source
        </a>
        .
      </p>
    </footer>
  );
}

export default Footer;
